import * as moment from "moment";

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";

import { CardType } from "../../cards/card-type";
import { DashboardService } from "../../dashboard.service";
import { EnquadradaDesenquadradaOutput } from "../enquadrada-filtro/EnquadradaDesenquadradaOutput";
import { EnquadradaFiltroComponent } from "../enquadrada-filtro/enquadrada-filtro.component";
import { EnquadradaModel } from "../enquadrada-filtro/EnquadradaModel";
import { Subject, Subscription } from "rxjs";
import { TabVo } from "../../../shared/models/tab-vo";
import { ToastService } from "maps-angular-components";
import { indicate } from "src/app/shared/util/loading-indicate";
import {MaskUtil} from "../../../shared/util/mask-util";
import {CarteiraCNPJ} from "../../../carteira/carteira.cnpj.model";
import {ModalDetalheProcessamentoComponent} from "../../../shared/modal-detalhe-processamento/modal-detalhe-processamento.component";
import {ModalUltimosDezProcessamentoComponent} from "../../../shared/modal-ultimos-dez-processamento/modal-ultimos-dez-processamento.component";
import {MatDialog} from "@angular/material/dialog";
import {DetalheProcessamentoFilter} from "../../../shared/modal-detalhe-processamento/detalhe-processamento-filter";

@Component({
  selector: "app-enquadrada",
  templateUrl: "./enquadrada.component.html",
  styleUrls: ["./enquadrada.component.scss"],
})
export class EnquadradaComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions = new Subscription();

  @Input() pageCadastroVO: TabVo;

  page$: Subject<number> = new Subject<number>();

  @ViewChild("filtroComponent", { static: false })
  filtroComponent: EnquadradaFiltroComponent;

  @Output()
  private afterViewInit: EventEmitter<TabVo> = new EventEmitter<TabVo>();
  cardType: CardType;
  CardType = CardType;
  paginationTotalPage: number = 1;
  totalRegistros: number = 0;
  loading$ = new Subject<boolean>();
  enquadradaModel: EnquadradaModel[] = [];

  constructor(
    private dashboardService: DashboardService,
    private messageService: ToastService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    let output = new EnquadradaDesenquadradaOutput();

    this.subscriptions.add(
      this.dashboardService.getUltimaDataProcessamento().subscribe(
        res => {
        if (res !== null && res) {
          output.dataUltimoProcessamento = res;
        }
        this.filtroComponent.setData(res);
        this.pesquisar(output);
      })
    );
  }

  pesquisar(value: EnquadradaDesenquadradaOutput, page = 1) {
    value.page = page - 1;
    value.statusProcessamento = "ENQUADRADA";
    this.enquadradaModel = [];
    this.totalRegistros = 0;

    this.subscriptions.add(
      this.dashboardService
        .findCarteirasByStatus(value)
        .pipe(
          indicate(this.loading$),
          indicate(this.filtroComponent.loading$)
        )
        .subscribe(
          (r) => {
            let metadata = r.metadata;
            if (metadata.totalElements > 0) {
              if (metadata.totalPages === 0) {
                this.paginationTotalPage = 1;
              } else {
                this.paginationTotalPage = Math.ceil(
                  metadata.totalElements / metadata.size
                );
              }
              this.totalRegistros = metadata.totalElements;
              this.enquadradaModel = r.content.map((e) =>
                Object.assign(new EnquadradaModel(), e)
              );
            } else {
              this.paginationTotalPage = 1;
            }
          },
          err => this.messageService.erro(err.error?.message || err.message)
        )
    );
  }

  receiverPage(value: any) {
    this.pesquisar(this.filtroComponent.getOutputNoInput(), value);
  }

  searchEvent(pageNumber: number) {
    this.page$.next(pageNumber);
  }

  showDetails(p: any) {
    this.dialog.open(ModalDetalheProcessamentoComponent, {
      data: new  DetalheProcessamentoFilter(p.id),
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  lastTenProcessingDialog(p: EnquadradaModel) {
    this.dialog.open(ModalUltimosDezProcessamentoComponent, {
      data: p.id,
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  public formatCnpj(cnpj: string) {
    return MaskUtil.formatCnpj(cnpj);
  }
}
